import { cn, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { useIsConservation } from '@/hooks/useIsConservation';
import { useLegalUrls } from '@/hooks/useLegalUrls';

import { ActionButton, InformationBox, InformationBoxEntry } from '../../../components';

export const DesktopView = () => {
  const { t } = useTranslation();

  const { privacyPolicyUrl, termsAndConditionsUrl } = useLegalUrls();
  const isConservation = useIsConservation();

  return (
    <Stack
      spacing={3}
      className={cn('mx-auto rounded', {
        'border border-neutral-black-12': !isConservation,
      })}
      data-testid='account-legal-page-desktop-view'
    >
      <InformationBox
        title={t('shared.account.titles.legalDocuments')}
        entries={[
          <InformationBoxEntry
            key='tc'
            label=''
            value={t('shared.account.labels.termsAndConditions')}
            ActionButton={
              <ActionButton label={t('shared.account.buttons.view')} isExternalLink link={termsAndConditionsUrl} />
            }
          />,
          <InformationBoxEntry
            key='pp'
            label=''
            value={t('shared.account.labels.privacyPolicy')}
            ActionButton={
              <ActionButton label={t('shared.account.buttons.view')} isExternalLink link={privacyPolicyUrl} />
            }
          />,
        ]}
      />
    </Stack>
  );
};
